enum PeriodType {
    Day = "DAY",
    Week = "WEEK",
    Month = "MONTH",
    Quarter = "QUARTER",
    Year = "YEAR",
    Maturity = "MATURITY"
}
export default PeriodType